import path from 'node:path';
import { buildFileIndexAsync } from './build-file-index.js';
import { bridgeFileIndexIsPopulated, bridgeFileIndexPathCount } from './search-file-index.js';

export async function ensureFileIndex(cwd: string): Promise<{ fromCache: boolean; pathCount: number }> {
  const resolved = path.resolve(cwd);
  if (await bridgeFileIndexIsPopulated(resolved)) {
    return { fromCache: true, pathCount: await bridgeFileIndexPathCount(resolved) };
  }
  return { ...(await buildFileIndexAsync(resolved)), fromCache: false };
}

export async function ensureFileIndexAsync(cwd: string): Promise<{ fromCache: boolean; pathCount: number }> {
  const resolved = path.resolve(cwd);
  if (await bridgeFileIndexIsPopulated(resolved)) {
    return { fromCache: true, pathCount: await bridgeFileIndexPathCount(resolved) };
  }
  return { ...(await buildFileIndexAsync(resolved)), fromCache: false };
}
